import * as React from 'react';
import {
  Menu, MenuItem,
} from '@material-ui/core';
import { useNavigate } from 'react-router-dom';

interface ScannerActionMenuProps {
  scannerId: string;
  anchorEl: HTMLElement;
  handleClose: () => void;
  handleDelete: () => void;
}

const ScannerActionMenu: React.FC<ScannerActionMenuProps> = (
  {
    scannerId, anchorEl, handleClose, handleDelete,
  },
) => {
  const navigate = useNavigate();
  const handleEditClicked = () => {
    navigate(`/scanner/${scannerId}`);
  };

  return (
    <Menu
      anchorEl={anchorEl}
      keepMounted
      open
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      onClose={handleClose}
    >
      <MenuItem id="edit-scanner-button" onClick={handleEditClicked}>{'Edit'}</MenuItem>
      <MenuItem id="delete-scanner-button" onClick={handleDelete}>{'Delete'}</MenuItem>
    </Menu>
  );
};
export default ScannerActionMenu;
